import type { ReactNode } from 'react';

import { SyncProvider } from '@/shared/offline';

import { SessionCacheGuard } from './SessionCacheGuard';
import { QueryProvider } from './QueryProvider';
import { SessionGate } from './SessionGate';
import { startImpersonationBridge } from './impersonation';

/*
 * Bij het laden, niet in een effect: het eerste verzoek van het eerste scherm
 * moet het impersonatietoken al dragen. Zie `impersonation.ts`.
 */
startImpersonationBridge();

/**
 * Volgorde is bewust: eerst de sessie (die bepaalt of er überhaupt iets te
 * halen valt), dan de querycache, dan de sync-engine die de outbox leegt.
 */
export function AppProviders({ children }: { children: ReactNode }) {
    return (
        <SessionGate>
            <QueryProvider>
                <SessionCacheGuard>
                    <SyncProvider>{children}</SyncProvider>
                </SessionCacheGuard>
            </QueryProvider>
        </SessionGate>
    );
}
